<script setup lang="ts">
import { useI18n } from 'petite-vue-i18n';
import Button from '../../General/Button.vue';
import { TEXT } from '../../../configs/text';
import Modal from '../../General/Modal.vue';
import { ref } from 'vue';
import Heading from '../../General/Heading.vue';
import AllowSpeakingList from './AllowSpeakingList.vue';
import { useClassStore } from '../../../stores';
import { ClassStatus } from '../../../types/class';

const modalShow = ref<boolean>(false)
const classStore = useClassStore()

const { t } = useI18n()
</script>

<template>
    <Button color="warning" @click="modalShow = true" class="ml-auto" :class="{ 'opacity-50': classStore?.selectedClassDetails?.state === ClassStatus.not_started }" :disabled="classStore?.selectedClassDetails?.state === ClassStatus.not_started">
        {{ t(TEXT.allow_speaking) }}
    </Button>
    <Modal v-model="modalShow" position="right" :full-height="true" background="gray">
        <div class="flex flex-col h-full">
            <Heading class="mb-5">{{ t(TEXT.allow_speaking) }}</Heading>
            <AllowSpeakingList @update="modalShow = false" />
        </div>
    </Modal>
</template>